import useClientQuery from './useClientQuery';

export type { ClientQueryCacheKey } from './useClientQuery';

export default useClientQuery;
